import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { NgxMaskModule } from 'ngx-mask';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, HttpClientModule, RouterModule, NgxMaskModule.forRoot()],
  declarations: [],
  exports: [CommonModule, FormsModule, ReactiveFormsModule, HttpClientModule, RouterModule, NgxMaskModule]
})
export class SharedModule {}
